import {IApplicationState} from '../../../../types/types';
import { getAuthUser } from './getAuthUser';
import { AUTH_USER_DEFAULT_ID } from '../constants';

export const isUserAuthorized = (state: IApplicationState): boolean => {
    const authUser = getAuthUser(state);
    return authUser && getAuthUser(state).anonym === false && authUser.id !== AUTH_USER_DEFAULT_ID;
};
